import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const CertificationCard = (prop) => {
  const cert = prop.item;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = (e) => {
    e.preventDefault();
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Card key={cert.id}>
        <ImageContainer>
          {cert.imageUrl && <Image src={cert.imageUrl} alt={cert.title} />}
          <Overlay>
            <ViewButton onClick={openModal}>View Certificate</ViewButton>
          </Overlay>
        </ImageContainer>
        <Divider>
          <CompanyName>{cert.category.toUpperCase()}</CompanyName>
        </Divider>
        <CardContent>
          <Title>{cert.title}</Title>
          <Date>{cert.date}</Date>
        </CardContent>
      </Card>

      {isModalOpen && (
        <Modal>
          <ModalContent>
            <CloseButton onClick={closeModal}>&times;</CloseButton>
            <ModalTitle>{cert.title}</ModalTitle>
            <CertificateContainer>
              {cert.imageUrl && <CertificateImage src={cert.imageUrl} alt={cert.title} />}
            </CertificateContainer>
            {/* <ModalInfo>
              <DetailItem>
                <DetailLabel>Category:</DetailLabel> {cert.category}
              </DetailItem>
              <DetailItem>
                <DetailLabel>Issued:</DetailLabel> {cert.date}
              </DetailItem>
              {cert.issuer && (
                <DetailItem>
                  <DetailLabel>Issuer:</DetailLabel> {cert.issuer}
                </DetailItem>
              )}
            </ModalInfo> */}
          </ModalContent>
          <ModalBackdrop onClick={closeModal} />
        </Modal>
      )}
    </>
  );
};

export default CertificationCard;

// Original Styled Components 
const Card = styled.div`
  width: 330px; 
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: transform 0.3s, box-shadow 0.3s;
  cursor: pointer;
  margin-bottom: 20px;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  height: 180px; 
  background-color: #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
  
  ${Card}:hover & {
    transform: scale(1.05);
  }
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  
  ${Card}:hover & {
    opacity: 1;
  }
`;

const ViewButton = styled.button`
  padding: 8px 16px;
  background-color: #ffd700;
  color: #292930;
  border: none;
  border-radius: 4px;
  font-weight: 600;
  transform: translateY(20px);
  transition: transform 0.3s ease;
  
  ${Card}:hover & {
    transform: translateY(0);
  }
  
  &:hover {
    background-color: #e6c300;
  }
`;

const Divider = styled.div`
  width: 100%;
  height: 4px;
  background-color: #ffd700; 
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CompanyName = styled.span`
  background-color: #ffd700;
  padding: 0 10px;
  font-size: 0.9rem;
  color: #555;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 1rem;
  font-weight: 600;
`;

const CardContent = styled.div`
  padding: 20px;
  text-align: left;
`;

const Title = styled.h3`
  font-size: 1.2rem;
  margin-bottom: 5px;
  color: #333;
  margin-bottom: 1.5rem;
  transition: color 0.3s ease;
`;

const Date = styled.span`
  font-size: 0.8rem;
  color: #777;
`;

// New Modal Styled Components
const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalBackdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  animation: fadeIn 0.3s ease;
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

const ModalContent = styled.div`
  position: relative;
  max-width: 800px;
  width: 100%;
  background-color: white;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
  z-index: 1001;
  animation: scaleIn 0.3s ease;
  scale : 0.8;

  @keyframes scaleIn {
    from { transform: scale(0.9); opacity: 0; }
    to { transform: scale(1); opacity: 1; }
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  font-size: 24px;
  background: none;
  border: none;
  cursor: pointer;
  color: #333;
  transition: color 0.2s;

  &:hover {
    color: #ffd700;
  }
`;

const ModalTitle = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 20px;
  color: #292930;
  text-align: center;
  border-bottom: 2px solid #ffd700;
  padding-bottom: 10px;
`;

const CertificateContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`;

const CertificateImage = styled.img`
  max-width: 100%;
  max-height: 500px;
  object-fit: contain;
  border: 1px solid #eee;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const ModalInfo = styled.div`
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 5px;
`;

const DetailItem = styled.div`
  margin-bottom: 8px;
  font-size: 0.9rem;
  color: #555;
`;

const DetailLabel = styled.span`
  font-weight: 600;
  color: #333;
`;